export { default as Call } from './Call';
export { default as Chat } from './Chat';
export { default as Claim } from './Claim';
export { default as FAQ } from './FAQ';
export { default as WhatsCovered } from './WhatsCovered';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/icons/index.ts